import styled, { css } from 'styled-components';

export const StyledLayout = styled.div`
  ${({ $showlayout }) =>
    $showlayout
      ? css`
          padding: 85px 15px 15px 15px;

          .sidebar-active & {
            .children::after {
              left: 0;
            }
          }

          @media (min-width: 1200px) {
            padding: 110px 20px 15px 80px;
            transition: all 0.3s ease-in-out;

            .sidebar-active & {
              padding: 110px 20px 15px 320px;
              .children::after {
                left: 200px;
              }
            }
          }
          @media (min-width: 1400px) {
            .sidebar-active & {
              padding: 110px 20px 15px 370px;
            }
          }
        `
      : css`
          padding: 0px;
        `}
  .children {
    width: 100%;

    &::after {
      content: '';
      background: var(--paper);
      width: 100%;
      position: fixed;
      bottom: 0px;
      right: 0px;
      display: inline-block;
      z-index: -1;
      height: 100dvh;
      background-position: bottom;
      background-size: 100% 100%;
      transition: all 0.3s ease-in-out;
    }

    ${({ $showlayout }) =>
      $showlayout
        ? css`
            min-height: calc(100dvh - 145px);
            display: flex;
            flex-direction: column;

            &::after {
              left: 40px;
            }
          `
        : css``}
  }
`;
